import React, { Fragment } from 'react';
import * as PropTypes from 'prop-types';
import { isSeniorStaff } from '../../lib/helper/authorisation';
import { niceDateTimeFormatter, userNameFormatter } from '../../lib/helper/formatting';
import { noteLines } from '../../lib/helper/patientNotes';

/**
 * MED-922 - one note about a person.
 *
 * Follows InvoiceNote's shape so the two kinds of note read the same on the invoice screen, with
 * two additions: a badge saying this note pops up, and the control that stops it. Clearing
 * `isPopup` is the only way a popup ever stops - there is no acknowledgement state - so the
 * control has to be here, on the note, where the person reading it can reach it.
 *
 * Delete is senior staff only, mirroring InvoiceNote.
 */
class PatientNote extends React.Component {
  render() {
    const { note, deleteNote, setPopup } = this.props;

    return (
      <div className="invoice-batch-single__note">
        <p className={'invoice-batch-single__note-content'}>
          {isSeniorStaff() && deleteNote && (
            <span className="action-icon mr-2" onClick={() => deleteNote(note.id)}>
              <span className="sr-only">Delete</span>
              <i className="fas fa-trash" title="Delete note" />
            </span>
          )}
          {niceDateTimeFormatter(note.createdAt)} - <strong>{userNameFormatter(note.createdBy)}</strong> said:
          {note.isPopup && (
            <span className="badge badge-warning ml-2" title="Shown as a pop-up whenever an invoice for this patient is opened">
              <i className="fas fa-bell mr-1" />
              Pops up
            </span>
          )}
          {setPopup && (
            <button
              type="button"
              className="btn btn-link btn-sm p-0 ml-2 align-baseline"
              onClick={() => setPopup(note.id, !note.isPopup)}
              title={note.isPopup ? 'Stop this note popping up on invoices' : 'Pop this note up whenever an invoice for this patient is opened'}>
              {note.isPopup ? 'Stop popping up' : 'Pop up on invoices'}
            </button>
          )}
        </p>

        {noteLines(note).map((line, key) => (
          <Fragment key={key}>
            {line}
            <br />
          </Fragment>
        ))}
      </div>
    );
  }
}

PatientNote.propTypes = {
  note: PropTypes.object.isRequired,
  deleteNote: PropTypes.func,
  setPopup: PropTypes.func,
};

export default PatientNote;
